import { DriverManagement } from "../DriverManagement";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutDriverManagementMultiProfile extends Layout {
    layoutDriverManagement: DriverManagement;
    sourceDriverManager: DataSource;
    sourceDriverManagerProfile: DataSource;
    tabProfile: Tab;
    tabsetDriverManagementProfiles: Tabset;
}
